import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { DireccionGeograficaIDE } from '@rpe/registro-personas-empresas-lib';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityDireccionesGeograficaIDEAdapter: EntityAdapter<DireccionGeograficaIDE> =
  createEntityAdapter<DireccionGeograficaIDE>({
    selectId: (model) => model.id,
    sortComparer: (
      a: DireccionGeograficaIDE,
      b: DireccionGeograficaIDE
    ): number => b.ranking - a.ranking
  });

export interface EntityDireccionesGeograficaIDEState
  extends EntityState<DireccionGeograficaIDE> {
  resultadosPorMapa: { [mapa: string]: DireccionGeograficaIDE[] }; 
  mapa: string  | null;  
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityDireccionesGeograficaIDEState =
  entityDireccionesGeograficaIDEAdapter.getInitialState({
    direccionGeograficaIDEExacta: null,
    resultadosPorMapa: {}, 
    mapa: null,
    isLoading: false,
    error: null
  });